import { RootState } from 'store/store';
import { JourneyError } from './types';
import { ERROR_TYPES } from 'pages/ExperienceCanvas/types';
import { getBackendJourneyErrors } from 'helpers/error.helper';

export function getSMSErrorList(state: RootState, refId: string, checkJourneyErrors = true): JourneyError[] {
  const smsState = state.te.sms;
  const language = state.settings.previewTextLanguage;
  const sms = smsState.byRefId[refId];

  const retVal: JourneyError[] = [];

  if (!sms) return retVal;

  const hasTemplate = !!sms.payload?.template?.[language]?.journeySMSTemplateId;
  if (!hasTemplate) retVal.push({ type: ERROR_TYPES.INCOMPLETE, err: 'Missing SMS template' });

  const dataComplete = Object.values(sms.payload?.template?.[language]?.journeySMSTemplateData ?? {}).every((v) => !!v);
  if (!dataComplete) retVal.push({ type: ERROR_TYPES.INCOMPLETE, err: 'Missing template field mappings' });

  if (!checkJourneyErrors) return retVal;

  const beErrors = Array.isArray(state.te.journey.errors) ? state.te.journey.errors : [];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { filteredErrors } = getBackendJourneyErrors(beErrors, state, (err: any) => {
    return err.component && err.component === 'sms' && err.refId && err.refId === refId;
  });
  retVal.push(...filteredErrors);

  return retVal;
}
